import {BlogPostType} from '@nls-2022/nls-api/';
import {updateIsPublished} from '@nls-2022/nls-api/';
//import {extractDate} from '@nls-2022/nls-bll/dist/common/utils';
import {extractDate} from '@nls-2022/nls-bll';
import * as React from 'react';
import {BlogPostsActionType} from '@nls-2022/nls-bll';
type BlogPostBasicDetailswithAction = {
  blogPost: BlogPostType;
  blogPostsDispatch: any;
};

type PuborUnPubAction = {
  blogPost: BlogPostType;
  handleBlogPostPubLishUnPublish: any;
};

//const handlePuborUnPubClick = ({isPublished,dispatch}:PuborUnPubAction): void => {
//
//}

const PublishUnpublish = ({
  blogPost,
  handleBlogPostPubLishUnPublish,
}: PuborUnPubAction) => {
  return (
    <button
      data-blogpostid={blogPost.ID}
      data-ispublished={blogPost.IsPublished}
      onClick={handleBlogPostPubLishUnPublish}
    >
      {blogPost.IsPublished ? 'unpub' : 'pub'}
    </button>
  );
};

const BlogPostsBasicDetails = ({
  blogPost,
  blogPostsDispatch,
}: BlogPostBasicDetailswithAction) => {
  const handleBlogPostPublishUnPublish = (ev: any) => {
    blogPostsDispatch({
      type: BlogPostsActionType.BlogPostUpdatePublished,
      actionPayload: {
        blogPostId: ev.target.dataset.blogpostid,
      },
    });
    let updateIsPublishedRes = updateIsPublished(
      ev.target.dataset.blogpostid,
      ev.target.dataset.ispublished,
    );
  };
  return (
    <section className="flex flex-row pb-1">
      <div className="hidden">{blogPost.ID}</div>
      <div className="basis-1/6 pr-2">{extractDate(blogPost.PubDate)}</div>
      <div className="hidden">
        {blogPost.IsPublished ? 'Published' : 'Unpublished'}
      </div>
      <div className="basis-1/4 pr-2 ">{blogPost.Title}</div>
      <div className="basis-1/4 pr-2">{blogPost.Excerpt}</div>
      <div className="basis-2/6 pr-2 flex flex-wrap flex-row">
        <PublishUnpublish
          blogPost={blogPost}
          handleBlogPostPubLishUnPublish={handleBlogPostPublishUnPublish}
        />
      </div>
    </section>
  );
};
export default BlogPostsBasicDetails;
